<template>
  <input
    :name="name"
    :type="type"
    :placeholder="placeholder"
    :required="isRequired"
    :pattern="pattern"
    class="input"
    :class="[ isMini && 'input--mini']"
    :maxlength="maxlength"
    :value="value"
    :readonly="readonly"
    @keypress="$event.target.classList.add('touched')"
    @keyup.enter="$emit('keyup', $event.target.value)"
    @input="$emit('input', $event.target.value)"
    @focus="$emit('focus')"
    @search="$emit('search', $event)"
  >
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'text'
      },
      name: {
        type: String,
        default: null
      },
      pattern: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      maxlength: {
        type: Number,
        default: null
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      isMini: {
        type: Boolean,
        default: false
      },
      value: {
        type: [String, Number, Date],
        default: null
      },
      readonly:{
        type:Boolean,
        default: false
      }
    }
  };
</script>

